import { useSize } from "../../lib/useSize";
import { fmtKpi, shortLabel, type ChartPoint } from "../../lib/dashboard";

/** Kütüphanesiz dikey çubuk grafik — ölçülen kutuya SVG çizer, token renk (var(--chart-N)). */
export function BarChart({ data, color, unit }: { data: ChartPoint[]; color: string; unit?: string | null }) {
  const [ref, { width, height }] = useSize<HTMLDivElement>();
  const vals = data.map((d) => d.value ?? 0);
  const maxV = Math.max(1, ...vals);
  const padL = 6, padR = 6, padT = 12, padB = 20;
  const plotW = Math.max(0, width - padL - padR);
  const plotH = Math.max(0, height - padT - padB);
  const n = data.length;
  const step = n > 0 ? plotW / n : 0;
  const bw = Math.max(3, Math.min(52, step * 0.62));
  return (
    <div ref={ref} className="dash-chart">
      {width > 8 && height > 8 && n > 0 ? (
        <svg width={width} height={height} role="img" aria-label="Çubuk grafik">
          <line x1={padL} y1={padT + plotH} x2={padL + plotW} y2={padT + plotH} stroke="var(--neutral-200)" strokeWidth={1} />
          {data.map((d, i) => {
            const v = Math.max(0, d.value ?? 0);
            const bh = maxV > 0 ? (v / maxV) * plotH : 0;
            const x = padL + i * step + (step - bw) / 2;
            const y = padT + plotH - bh;
            return (
              <g key={i}>
                <rect x={x} y={y} width={bw} height={Math.max(0, bh)} rx={2} fill={color}>
                  <title>{d.label}: {fmtKpi(d.value)}{unit ? " " + unit : ""}</title>
                </rect>
                {n <= 16 ? <text x={x + bw / 2} y={padT + plotH + 13} textAnchor="middle" className="dash-chart-x">{shortLabel(d.label)}</text> : null}
              </g>
            );
          })}
        </svg>
      ) : null}
    </div>
  );
}
